// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8c420c8d","513":"635762aa","703":"b19b67ae","787":"82829f84"}[chunkId] + ".chunk.js";
};